import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import { Box } from "Components/Base/Layout/Box";
import { Badge } from "Components/Base/DataDisplay/Badge";
import TotalProgressSection from "./components/TotalProgressSection";
import ToggleButtonGroupStatus from "./components/ToggleButtonGroupStatus";
import DrawerFilters from "./components/DrawerFilters";
import ButtonFilter from "./components/ButtonFilter";
import SelectFilter from "./components/SelectFilter";
import * as CONSTANTS from "../constants";

const PageFilter = ({
  store,
  mediaClass,
  languageContext,
  setFilter,
  setSortBy,
  setSearchText,
  state,
  setState,
  onSearch,
  hitCount,
  showHitCount,
  totalPercentCompleted,
}) => (
  <>
    <BaseGrid
      childWidth="auto"
      justifyContent="space-between"
      alignItems="center"
    >
      <BaseGrid childWidth="auto" alignItems="center">
        <ToggleButtonGroupStatus
          value={state.filterStatus}
          languageContext={languageContext}
          onClick={setFilter}
        />
        <SelectFilter
          className="filter-sort-select"
          name={languageContext("sort")}
          options={CONSTANTS.SORT_OPTIONS_ORDER}
          value={state.sortBy}
          onChange={setSortBy}
          languageContext={languageContext}
          displayLabel={false}
          sx={{ height: "46px" }}
          translateOptions={true}
        />
        <Badge
          badgeContent={hitCount && showHitCount ? hitCount : 0}
          color="primary"
        >
          <ButtonFilter
            state={state}
            setState={setState}
            languageContext={languageContext}
          />
        </Badge>
      </BaseGrid>

      <Box>
        <TotalProgressSection
          totalPercentCompleted={totalPercentCompleted}
          languageContext={languageContext}
          scale={1}
        />
      </Box>
    </BaseGrid>
    <DrawerFilters
      state={state}
      setState={setState}
      store={store}
      mediaClass={mediaClass}
      showHitCount={showHitCount}
      hitCount={hitCount}
      languageContext={languageContext}
      setSearchText={setSearchText}
      setSortBy={setSortBy}
      setFilter={setFilter}
      onSearch={onSearch}
    />
  </>
);

export default PageFilter;
